import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';

import ContentsAudit from '@bo-layout/contents/ContentsAudit';

const ContentsPageInformation = ({ audit, children }) => {
  return (
    <Container>
      {children}
      {audit && <ContentsAudit {...audit} />}
    </Container>
  );
};

export default ContentsPageInformation;

ContentsPageInformation.propTypes = {
  audit: PropTypes.shape({
    createDate: PropTypes.string,
    creatorName: PropTypes.string,
    updateDate: PropTypes.string,
    updaterName: PropTypes.string,
  }),
  children: PropTypes.node,
};

const Container = styled(FlexBox)`
  height: 52px;
  justify-content: flex-end;
  flex-grow: 1;

  background-color: ${boTheme.color.sub10};

  position: sticky;
  top: 0;
  z-index: 5;
`;
